import { useQuery } from "@tanstack/react-query";

import { QUERY_REFETCH_INTERVAL_MS_30S } from "~/constants";

import { notificationQueryOptions } from "./api/notification-query-options";

/**
 * Whether the registry serves an inbox, read from the unread-count query so it costs no extra request.
 * `hasInbox` is `undefined` until the first answer; a later failure keeps the last answer rather than dropping it.
 * A failed check is retried every 30 seconds; a 404 is an answer and is not retried.
 */
export function useInboxAvailability() {
  const query = useQuery({
    ...notificationQueryOptions.unreadCount(),
    select: (data) => data !== null,
    refetchInterval: (query) => (query.state.status === "error" ? QUERY_REFETCH_INTERVAL_MS_30S : false),
  });
  return { hasInbox: query.data, isLoading: query.isLoading, isError: query.isError };
}
